import type { MissionStatusCode, PublicElimination, RankingEntry } from '@killer-party/contracts';
import { agentName } from './format';

// Ligne du rapport final : classement (TD-016) complete par les eliminations (TD-021).
export interface ReportEntry {
  rank: number;
  firstName: string;
  codeName: string;
  statusCode: MissionStatusCode;
  score: number;
  // Agents nommes par agentName (nom de code et prenom).
  victims: string[];
  eliminatedBy: string | null;
}

// Les deux listes sont associees par nom de code, unique parmi les agents classes (TD-021).
export function buildFinalReport(
  ranking: RankingEntry[],
  eliminations: PublicElimination[],
): ReportEntry[] {
  return ranking.map(({ rank, firstName, codeName, statusCode, score }) => ({
    rank,
    firstName,
    codeName,
    statusCode,
    score,
    victims: eliminations
      .filter((e) => e.hunter.codeName === codeName)
      .map((e) => agentName(e.victim)),
    eliminatedBy: hunterOf(eliminations, codeName),
  }));
}

function hunterOf(eliminations: PublicElimination[], codeName: string): string | null {
  const hunter = eliminations.find((e) => e.victim.codeName === codeName)?.hunter;
  return hunter ? agentName(hunter) : null;
}
